/* ****************************************************************************
Name:			  Cerfificate upload
**
** Desc:         This code is to manager supplier certificates
** Author:        VAsu Pabbaraju
** Date:          2020/08/01

*******************************************************************************
**       CHANGE HISTORY
*******************************************************************************
**  Date			    Author					 Description
**  ----------  -----------------------  --------------------------------------
**  10/26/2020  Vasu Pabbaraju.           Added force update s3 file upload file/delete file - Q360-384
                                          Line Numbers: 82,217, 265, 311
**  11/24/2020  Vasu Pabbaraju.           Changed file upload chunksize to 150000000

******************************************************************************/ 


import React, { useEffect, useState , useRef} from 'react';
import { useDropzone } from 'react-dropzone';
import { withRouter } from "react-router-dom";
import axios from 'axios';
import { FileUploader} from 'devextreme-react/file-uploader';
import DataTable from 'react-data-table-component'
import {
   Row, Col, CardBody, CardHeader,Modal,ModalBody,Button,
  Card
} from 'reactstrap';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import gql from 'graphql-tag';
import { useLazyQuery} from '@apollo/react-hooks';
import SweetAlert from 'react-bootstrap-sweetalert';
import * as FileSaver from 'file-saver';
// import { Button } from 'react-bootstrap/lib/InputGroup';

//Get Supplier certificates call config
const GET_CERTIFICATES = gql`
  query getCertificates($FileGUID: String){
    SupplierCertificates(filters: {
      FileGUID: $FileGUID
}) {
 edges {
   node {
    FileGUID
    FileName
    FileLocation
    LoadTS
    UpdateTS
    SupplierLogID
   }
 }
}
}

`;



const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};


const FileUploaderObj = (options) => {
  const fileUploaderRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [chunksObject, setChunks] = useState([]);
  const [percent, setPercent] = useState(0);
  const [certFiles, setCertFiles] = useState(null);
  const [certificates, setCertificates] = useState(null);
  const [showDeleteFile, setShowDeleteFile] = useState(false);
  const [SelectedFile, setSelectedFile] = useState(null);
  const [showFileUploadError, setShowFileUploadError] = useState(false);
  const [fileUploadErrorMessage, setFileUploadErrorMessage] = useState(null);
  const [refresh,setRefresh] = useState(null);
  const [lots,setLots] = useState(null);
  const [lotsloading, setlotsloading] = useState(false);
  const [showLoading, setShowLoading] = useState(null);
  const [showResubmit, setShowResubmit] = useState(false);
  options.header['userid'] = JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase();
  const columns = [
    {
      name: "File Name",
      cell: (row) => (
        <div style={{ maxWidth: "80%", whiteSpace: "pre-wrap" }}>
          {row.node.FileName}{" "}
        </div>
      ),
      selector: "node.VendorNum",
      sortable: true,
      grow: 3,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    {
      name: "Uploaded By",
      selector: "node.SupplierLogID",
      sortable: true,
      grow: 3,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    {
      name: "Uploaded On",
      selector: "node.LoadTS",
      sortable: true,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    {
      name: "",

      cell: (row) => (
        <i
          style={{
            display:
              options.lots &&
              options.lots.length === 0 &&
              (( options.header.Status == "Processed") || options.header.Status == "Draft")
                ? "inline"
                : "none",
          }}
          onClick={() => {
            setSelectedFile(row);
            setShowDeleteFile(true);
          }}
          class="fas fa-trash-alt"
        ></i>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <i
          onClick={(e) =>
            downloadFile(
              row.node.FileLocation + row.node.FileName,
              row.node.FileName,
              row.node.InspectionID
            )
          }
          class="fas fa-cloud-download-alt"
        ></i>
      ),
    },
  ];

    const downloadFile = (e,FileName, FileGUID) => {
      //  let fileName = e.target.value;
      setShowLoading(true);
      let fileName = e;
      let fileURL = "";
       const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
    
       let  url = window.location.origin  + '/download_certifcate';
       if (window.location.hostname == 'localhost') {
           url = 'http://'+ window.location.hostname + ':5000/download_certifcate';
       }
    
       fetch( url, {
        method: 'POST',
        body: JSON.stringify({file_name:e}),
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'application/pdf',
          'authorization': token || null,
          'authVendorID': localStorage.getItem('loggedInVendor')

        }
      }).then(res => res.blob())
        .then(blob => {
        
          FileSaver.saveAs(blob, FileName );
          setShowLoading(false);
        }).catch(err => {
          console.log(err);
          setShowLoading(false);
        }
          );
    
    
     }


  let uploadURL = window.location.origin + '/upload';
  if (window.location.hostname == 'localhost') {
    uploadURL = 'http://' + window.location.hostname + ':5000/upload';
  }
  const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;


  options['header']['authorization'] = token;
  options['header']['authVendorID'] = localStorage.getItem('loggedInVendor');
  options['header']['Mode'] = 'Initial';




  const fileConfig = {
    multiple: true,
    uploadMode: 'instantly',
    accept: '.pdf',
    selectedFiles: []
  };

  if (options['header']) {
    options['header']['reportFileGUID'] = options['reportFileGUID'];
    options['header']['vendorNum'] = localStorage.getItem('loggedInVendor');
    if (options['certificates'] && !certificates) {
      setCertificates(options['certificates']);
    }
  }

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({

    onDrop: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })));
    }
  });

  const files1 = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      </li>
  ));


  //Get List of certificates 
  const [getCertificates] = useLazyQuery(GET_CERTIFICATES, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      console.log(data.SupplierCertificates.edges);
      setCertificates(data.SupplierCertificates.edges);
      options.updateCertificates(data.SupplierCertificates.edges);
      // setRefresh(new Date());
      // var handleToUpdate = options.handleToUpdate;
      // handleToUpdate();
      
      // options['certificates'] = data.SupplierCertificates.edges;
    }
  });

  

  useEffect(() => {
    handleFileUpload();
  }, [files]);

  useEffect(() => {
    // setRefresh(new Date());
    getCertificates({ variables: { FileGUID: options.reportFileGUID } });
    

    
  },[refresh]);


  const handleFileUpload = () => {

    let url = window.location.origin + '/upload';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/upload';
    }
    const formData = new FormData();
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;

    let filesLoaded = 0;
    let loadStatus = "";
    for (var i = 0; i < files.length; i++) {
      const formData = new FormData();
      let file = files[i];
      formData.append('files[' + i + ']', file);

      formData.append('headerObject', JSON.stringify(options.header));
      formData.append('fileGUID', options.reportFileGUID);
      formData.append('vendorNum', JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase());

      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          'authorization': token || null,
          'authVendorID': JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase(),
          'userid': JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username.replace('@corp.intusurg.com', '').toUpperCase()
        }
      }

      axios.post(url, formData, config).then(function (response) {

        if (response.data.status) {
          filesLoaded++;
          if (filesLoaded == files.length) {
            
            getCertificates({ variables: { FileGUID: options.reportFileGUID } });
          }
        } else {


          //   setShowLoading(false);
          //   setShowFileUpload(false);
          alert('Failed to load files');
        }


      }).catch(error => {

        // setShowLoading(false);
        // setShowFileUpload(false);
        alert('Failed to load files, please try again');
      });
    }
    return loadStatus
  }

      const deleteFileAPI  = (record) =>{ 
      const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
      let url = window.location.origin + '/file_delete';
      if (window.location.hostname == 'localhost') {
        url = 'http://' + window.location.hostname + ':5000/file_delete';
      }

      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ fileData: record }),
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'application/octet-stream',
          'authorization': token || null,
          'authVendorID': localStorage.getItem('loggedInVendor')
        }
      }).then(res => {
        // FileSaver.saveAs(blob, 'Inspection_details' + fileGuid + '.xlsx');
        // setShowLoading(false);
        // setShowLoader(false);
        // getCertificates({ variables: { FileGUID: options.reportFileGUID } });
        // console.log('1');
      //  console.log('2')
        // setRefresh(new Date());
        // console.log('3');
        // updateTable();
        // setRefresh(new Date());
        console.log('3');
        updateTable();
        console.log('4');
      }).catch(err => alert('Unable to download data'));

  }
  //Delete loaded certificates function
  //This functions makes an API call to delete the file from DB as well as S3 Bucket
  const deleteFile = () => {
    
    // setShowLoading(true);
    setShowDeleteFile(false);
    
    if (SelectedFile) {
      deleteFileAPI(SelectedFile);  
    }
    if (selectedRows.length > 0) {
      selectedRows.map((record) => {
        deleteFileAPI(record);
      });
      setSelectedRows([]);
     
  }
  setToggleCleared(!toggleCleared);
}


  const onUploadProgress = (e) => {
    //console.log(e)  

    const chunk = {
      segmentSize: e.segmentSize,
      bytesLoaded: e.bytesLoaded,
      bytesTotal: e.bytesTotal,
      fileGUID: options.reportFileGUID
    };

    setChunks([...chunksObject, chunk]);
    let t_percent = percent;
    t_percent = ((e.bytesLoaded / e.bytesTotal) * 100).toFixed(0);

    if (e.bytesTotal == e.bytesLoaded) {
      setPercent(100);
    }
    setPercent(t_percent);
  }

  const onUploadStarted = () => {
    setChunks([]);
  }

  const onUploadFinished = () => {
    console.log('Upload Finished');
    // Clear the file selection in the FileUploader UI
    if (fileUploaderRef.current) {
      fileUploaderRef.current.instance.reset();
    }
  }


  const onUploadError = (data) => {
    console.log('Error:', data.error);
    if (data.error.response) {
      setShowFileUploadError(true);
      setFileUploadErrorMessage('Invalid File or File Name, Only .pdf (small letters) files are allowed. Please check the file and try again.');

      // setFileUploadErrorMessage(JSON.parse(data.error.response)['message']);
    }
    
  }

  const updateTable = (data) => {
    setRefresh(new Date());
   
  }
  const getValueInKb = (value) => {
    return `${(value / 1024).toFixed(0)}kb`;
  }

  const resubmitDocuments = () => {
    setShowResubmit(true);
    console.log(options)
    let url = window.location.origin + '/upload';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/upload';
    }
    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ fileData: options.reportFileGUID }),
      headers: {
        'Content-Type': 'application/json',
        'responseType': 'application/json',
        'authorization': token || null,
        'authVendorID':localStorage.getItem('loggedInVendor'),
        'reportFileGUID' :options['header']['reportFileGUID'],
        'vendorName': localStorage.getItem('loggedInVendorName'),
        'vendorNum' :options['header']['vendorNum'],
        'PONum' :options['header']['PONum'],
        'PartNum' : options['header']['PartNum'],
        'SubLotNum' :options['header']['SubLotNum'],
        'AgileDocIDVer' : options['header']['AgileDocIDVer'],
        'MasterLotNum' :options['header']['MasterLotNum'],
        'userid' : options['header']['userid'],
        'mode':"resubmit"
      }
    }).then(res => {
      setShowResubmit(false);
      
  })
 


}

const [selectedRows, setSelectedRows] = React.useState([]);
const [toggleCleared, setToggleCleared] = React.useState(false);

const [errorMessage, setErrorMessage] = useState(null);
const maxFileSize = 204857600; // 100MB



const handleDelete = () => {
   console.log('Selected Rows: ', selectedRows);
   setShowDeleteFile(true);
    
}

// const handleValueChanged = (e) => {
//   const selectedFiles = Array.from(e.value);
//   console.log("selectedFiles:: ", selectedFiles);
//   if (selectedFiles.length > 2) {
//     console.log("You can only upload a maximum of 2 files at a time.");
//     alert("You can only upload a maximum of 2 files at a time.");
//   } else {
//     console.log("Selected files:", selectedFiles);
//     setFiles(selectedFiles);
//     console.log("Selected files:", selectedFiles);
//   }
// };

const handleValueChanged = (e) => {
  const selectedFiles = Array.from(e.value);
  if (selectedFiles.length > 20) {
    alert("You can only upload a maximum of 20 files at a time.");
    
    // Clear the selected files
    if (fileUploaderRef.current) {
      fileUploaderRef.current.instance.reset();
    }
  } else {
    // setFiles(selectedFiles);
    // console.log("Selected files:", selectedFiles);
  }
};

// const handleValueChanged = (e) => {
//   const file = e.value[0];
//   if (file && file.size > maxFileSize) {
//     setErrorMessage(`File size exceeds the limit of ${maxFileSize / 1048576} MB. Please upload a smaller file.`);
//     e.cancel = true; // Prevent the file from being uploaded
//   } else {
//     setErrorMessage(null); // Clear any previous error message if file size is within limit
//   }
// };
const handleRowSelected = React.useCallback(state => {
  setSelectedRows(state.selectedRows);

  console.log('Selected Rows: ', state.selectedRows);
}, []);



  return (
    <>
      <Modal isOpen={showLoading} toggle={showLoading}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            marginTop: "20px",
            verticalAlign: "center",
          }}
        >
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Processing</span>
          </div>
          <div style={{ width: "100%", textAlign: "center", fontSize: "20px" }}>
            Downloading .....{" "}
          </div>
        </div>{" "}
      </Modal>
      <Modal isOpen={showResubmit} toggle={showResubmit}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            marginTop: "20px",
            verticalAlign: "center",
          }}
        >
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Processing</span>
          </div>
          <div style={{ width: "100%", textAlign: "center", fontSize: "20px" }}>
            Submitting Documents .....{" "}
          </div>
        </div>{" "}
      </Modal>

      <div className="widget-container">
        <Row>
          <Col lg={8}>
            <Card>
              <CardHeader>Certificates Uploaded

              <div className="btn-actions-pane-right">
            <div role="group" className="btn-group-sm btn-group">
              {( options.header.Status == "Processed" && (options.lots && options.lots.length == 0 ))?
              <Button onClick={() => resubmitDocuments()}  color="primary" style={{ float: "right", marginRight: "10px" }}  >
                Resubmit Documents{" "}
              </Button>: null}
            </div>
            </div>


              </CardHeader>
             {selectedRows && selectedRows.length > 0 ? (
                <>
                  <CardHeader>
                    <Col lg={3}>
                        <Button key="delete" onClick={handleDelete} style={{ color: 'red' }}>
                        Delete
                      </Button>
                    </Col>
                    <Col lg={3}>
                      {
                        selectedRows.length > 1 ? (
                          <p> {selectedRows.length} files selected </p> ) : ( <p> {selectedRows.length} file selected </p> )
                      }
                    </Col>
                    </CardHeader>
              </>
             ): null 
              
              }
              <CardBody>
                {certificates ? (
                  <DataTable
                    selectableRows
                    // contextActions={contextActions}
			              onSelectedRowsChange={handleRowSelected}
			              clearSelectedRows={toggleCleared}
                    title="Google Sheets-esqe"
                    columns={columns}
                    data={certificates}
                    highlightOnHover
                    pointerOnHover
                    pagination
                  />
                ) : null}
              </CardBody>
            </Card>
          </Col>
          {((options.lots && options.lots.length == 0 ) || (!options.header.Status))?(
            <Col lg={4}>
              <Card style={{minHeight: '100%'}}>
                <CardHeader>Upload Certificates</CardHeader>
                <CardBody>
                  <div className="main-block">
                  <p>
                  You can drop multiple files and Invalid files will be automatically skipped.
                 </p>
                    <div className="file-uploader-block">
                      <FileUploader
                       ref={fileUploaderRef}
                        id="files"
                        maxFileSize={maxFileSize}
                        // chunkSize={chunkSize}
                        elementAttr={options.header}
                        uploadHeaders={options.header}
                        onValueChanged={handleValueChanged}
                        multiple={fileConfig.multiple}
                        // uploadMode={"useButtons"}
                        accept={fileConfig.accept}
                        // uploadMode={fileConfig.uploadMode}
                        name="files"
                        uploadUrl={uploadURL}
                        chunkSize={150000000}
                        onUploaded={(data) => updateTable(data)}
                        onUploadError={onUploadError}
                        onUploadStarted={ onUploadStarted}
                        onDropZoneEnter={onUploadFinished}
                        onProgress={onUploadProgress}
                      /> 
                      {/* <div style={{ marginTop: "10px" }}
                      >
                          {errorMessage && <div style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</div>}
  
                      </div> */}
                      <br/><p>
                      Allowed files extensions are <b>.pdf</b>.
                     </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ) : null}
        </Row>

        <SweetAlert
          show={showFileUploadError}
          error
          confirmBtnText="Ok"
          confirmBtnBsStyle="danger"
          title="File Upload Error"
          onConfirm={() => setShowFileUploadError(false)}
        >
          {fileUploadErrorMessage}
        </SweetAlert>

        <SweetAlert
          show={showDeleteFile}
          warning
          showCancel
          confirmBtnText="Yes, delete it!"
          confirmBtnBsStyle="danger"
          title="Are you sure?"
          onConfirm={() => deleteFile()}
          onCancel={() => setShowDeleteFile(false)}
          focusCancelBtn
        >
          You will not be able to recover this file!
        </SweetAlert>
      </div>
    </>
  );

}

export default (withRouter(FileUploaderObj))
